import axios from '../javascript/custom-axios';

export default {
  getInfo() {
    return axios.get(`/reports/general-summary`);
  },
};
